import { MunduEvent } from 'src/domain/event';
import { UserRole, isOrganizationRole } from 'src/domain/user';

export const canManageCalendarEvent = (
    event: MunduEvent,
    role: UserRole | undefined,
    userId: string | undefined,
    isOrganizationAdmin = false,
): boolean => {
    if (isOrganizationAdmin || isOrganizationRole(role)) return true;
    return (
        role === UserRole.creator &&
        Boolean(userId && event.createdById === userId)
    );
};
